import React, {useRef, useState} from 'react'
import { AppBar,Box,Toolbar,Typography,Button,IconButton,Tooltip,TextField } from '@mui/material'
import PreviewIcon from '@mui/icons-material/Preview';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import UploadIcon from '@mui/icons-material/Upload';
import {useSurveyStore} from '../surveyutilities/surveyStore';
import CustomDialog from '../editorparts/smallcomponents/CustomDialog.jsx'


function EcxSurveyTopbar({onSave,onPublish}) {
    const exportToJSON = useSurveyStore((state)=>state.exportToJSON);
    const loadFromJSON = useSurveyStore((state)=>state.loadFromJSON);
    const resetStore = useSurveyStore((state)=>state.resetStore);
    const togglePreviewMode = useSurveyStore((state)=>state.togglePreviewMode);
    const isPreviewMode = useSurveyStore((state)=>state.isPreviewMode);
    const [jsonContent,setJsonContent]=useState(null);
    const [importJson,setImportJson]=useState('');
    const dialogRef = useRef();
    const importDialogRef = useRef();

    const handleExportJson = ()=>{
        setJsonContent(exportToJSON());
        dialogRef.current.handleOpen();

    }
    const handleImportJson = ()=>{
        importDialogRef.current.handleOpen();
    }
    const handleImportConfirm = ()=>{
        try {
            const parsedJson = JSON.parse(importJson);
            loadFromJSON(parsedJson);
            setImportJson('');
            importDialogRef.current.handleClose();
        } catch (error) {
            alert('Invalid JSON format. Please check your input.');
        }
    }
    const handlePreview = ()=>{
        togglePreviewMode();
    }
    const handleResetClick=()=>{
        if (window.confirm('Are you sure you want to reset the canvas? This will clear all questions and settings.')) {
            resetStore();
        }
    }
    const handleSave = () => {
        const surveyData = exportToJSON();
        // Only set id to null if it's a new survey (no existing id)
        if (!surveyData.survey.id) {
            surveyData.survey.id = null;
        }
        if (onSave) {
            onSave(surveyData);
        }
    }
    return (
        <>
            <Box sx={{flexGrow:1,mb:2}}>
                <AppBar position="static" style={{ borderRadius: 10}} sx={{border:0,boxShadow: 1}} color='transparent' >
                    <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Left Section */}
                        <Typography variant="h6" component="div">
                            Survey Editor
                        </Typography>

                        {/* Right Section */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Tooltip title="Import JSON">
                                <IconButton color="inherit" onClick={handleImportJson}>
                                    <UploadIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Export JSON">
                                <IconButton color="inherit" onClick={handleExportJson}>
                                    <DataObjectIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Preview">
                                <IconButton color="inherit" onClick={handlePreview}>
                                    <PreviewIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Reset Canvas">
                                <IconButton color="inherit" onClick={handleResetClick}>
                                    <LayersClearIcon />
                                </IconButton>
                            </Tooltip>

                            {/* Show buttons only if callbacks exist */}
                            {onSave && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSave}
                                    sx={{ ml: 2 }}
                                >
                                    Save
                                </Button>
                            )}
                            {onPublish && (
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={onPublish}
                                    sx={{ ml: 1 }}
                                >
                                    Publish
                                </Button>
                            )}
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <CustomDialog
                ref={dialogRef}
                title="Export Json"
                onConfirm={() => {
                    navigator.clipboard.writeText(JSON.stringify(jsonContent, null, 2));
                    alert('JSON copied to clipboard!');
                }}
            >
                {/* Display Json Object*/}
                <pre>{jsonContent && JSON.stringify(jsonContent,null,2)}</pre>
            </CustomDialog>
            <CustomDialog
                ref={importDialogRef}
                title="Import JSON"
                onConfirm={handleImportConfirm}
            >
                <TextField
                    fullWidth
                    multiline
                    rows={10}
                    label="Paste JSON here"
                    value={importJson}
                    onChange={(e) => setImportJson(e.target.value)}
                    placeholder='{"survey": {...}, "questions": [...]}'
                    variant="outlined"
                />
            </CustomDialog>
        </>
    )
}

export default EcxSurveyTopbar